import { AppLayout } from "../shared";
import AccountSettings from "../MasterOrg/AccountSettings";

const MasterOrgAccount_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <AccountSettings props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgAccount_layout;
